<template >
    <div class="w-100">
        <div v-if="load">
              <loading />

        </div>
        <div v-else class="w-100 my-3 recargosFormType" >
            
            <div class="container-fluid" >

                <div class="row w-100">
                    <div class="col-5">
                        <ui-textbox
                            label="Nombre"
                            class="w-100"
                            placeholder="Ingrese Nombre..."
                            v-model="name"
                        />
                    </div>

                    <div class="col-5">
                        <ui-textbox
                            label="Código"
                            class="w-100"
                            placeholder="Ingrese Código..."
                            v-model="code"
                        />
                    </div>

                    <div class="col-5">
                        <ui-select 
                            class="w-100" 
                            label="Descripcion" 
                            placeholder="Seleccione"
                            :keys="{ value: 'id', label: 'name' }" 
                            :options="tariffRechargeDescription"
                            has-search
                            searchPlaceholder="Buscar"
                            v-model="description"
                            
                        />
                    </div>

                    <div class="col-5">
                        <ui-select 
                            class="w-100" 
                            label="Código Logistaas" 
                            placeholder="Seleccione"
                            :keys="{ value: 'id', label: 'name' }" 
                            :options="logistaasOptions"
                            has-search
                            searchPlaceholder="Buscar"
                            v-model="logistaasRecharge"
                        />
                    </div>
                </div>

            </div>
            <div class="container-fluid mt-3">
                <div class="row w-100">
                    <div class="col-3">
                        <button class="btn btn-default" @click="closeModal()" :disabled="disabledBtn">Cerrar</button>
                    </div>
                    <div class="col-9" v-if="!disabledForm">
                        <button 
                            v-if="action == 'add'"
                            class="btn btn-success float-right" 
                            @click="send()" 
                            :disabled="disabledBtn"
                        >
                            Agregar
                        </button>

                        <button 
                            v-if="action == 'update'"
                            class="btn btn-success float-right" 
                            @click="update()" 
                            :disabled="disabledBtn"
                        >
                            Actualizar
                        </button>

                        <button 
                            v-if="showReset"
                            class="btn btn-default float-right mr-3" 
                            @click="resetForm()" 
                            :disabled="disabledBtn"
                        >
                            Limpiar
                        </button>

                    </div>
                </div>
                
            </div>    
        </div>
    </div>
</template>

<script>

import { mapActions,mapState } from "vuex";

import { getRechargeTypes,actualizarTiposRecargos, validarTiposRecargos, agregarTiposRecargos } from '../../../../../constants/lineas';

import Loading from "../../../../common/loading";

export default {
    components: {
        Loading
    },
    props: {
        closeModal: { type: Function, default: () => {} },
        showReset: { type: Boolean, default: true },
        action: { type: String, default: "add" },
        disabledForm: { type: Boolean, default: false },
    },
    data() {
        return {
            code:"",
            name:"",
            id:"",
            descriptions:[],
            description:{},
            logistaasRecharge: {},

            disabledBtn: false,
            load: false
        }
    },
    computed: {
      ...mapState("lineas", ["dataEditarRecargoType","tariffRechargeDescription","logistaasOptions"]),
    },
    methods: {

        ...mapActions([ 'ActionSetLoadingTable']),
        ...mapActions("lineas", ["actionSetDataDatatableTarifasRecargos",'actionSetDataDatatableTarifasRecargosTypes','actionSetRecargoTypeLoading']),

        validForm(){    

            if( !this.name ){
                this.$vToastify.error("Campo Nombre requerido", "¡Error!");
                return false ;
            }

            if( !this.code ){
                this.$vToastify.error("Campo Código requerido", "¡Error!");
                return false ;
            }
            if( !this.description.id ){
                this.$vToastify.error("Campo Descripción requerido", "¡Error!");
                return false ;
            }
            if( !this.logistaasRecharge.id ){
                this.$vToastify.error("Campo Código Logistaas requerido", "¡Error!");
                return false ;
            }

            return true ;
        },


        async send(){
            const valid = this.validForm();

            if( !valid ) return ; 

            this.disabledBtn = true ;

            const form = {
                name : this.name ?? "",
                code : this.code ?? "",
                logistaasRecharge : this.logistaasRecharge.id ?? "",
                description : this.description.id ?? ""
            } ;

            this.$vToastify.loader("Agregando Tipo De Recargo...");

            let isValid = false ;

            try {
                const { data } = await validarTiposRecargos( form.code );
                isValid = data.valid ;

            } catch (error) {

                this.$vToastify.stopLoader();
                isValid = false ;
            }

            if( !isValid ){
                this.disabledBtn = false ;
                this.$vToastify.stopLoader();
                return this.$vToastify.error("El Código ya se encuentra en nuestros registros", "¡Error!");
            } 
                
            try {
                await agregarTiposRecargos( form );
                this.disabledBtn = false ;
                this.$vToastify.stopLoader();
                this.resetForm();
                this.closeModal();
                this.getRecargosTipos();
                
            } catch (error) {
                this.disabledBtn = false ;
                this.$vToastify.stopLoader();
                return this.$vToastify.error("Error al agregar Tipo de recargo, recargue la página y vuelva a intentar", "¡Error!");
            }


        },
        resetForm (){

            this.name = "" ;
            this.code = "" ;
            this.logistaasRecharge = {} ;
            this.description = {} ;
        },


        async getRecargosTipos(){
            
            this.actionSetRecargoTypeLoading(true);
            
            const { data } = await getRechargeTypes() ;

            const data_table = !data.data ? [] : data.data.map( d => ({
                data: [ d.code, d.name, d.description.name, d.logistaas_code.name ],
                data_complementaria: d 
            })) ;
            
            this.actionSetDataDatatableTarifasRecargosTypes(data_table);
            this.actionSetRecargoTypeLoading( false ) ;
        },

        async update(){
            const valid = this.validForm();

            if( !valid ) return ; 

            this.disabledBtn = true ;
            const form = {
                id : this.id ?? null,
                name : this.name ?? "",
                code : this.code ?? "",
                
                description : this.description.id ?? null,
                
                logistaasRecharge : this.logistaasRecharge ?? null
            } ;

            this.$vToastify.loader("Actualizando Tipo de Recargo...");

            try {
                await  actualizarTiposRecargos( form ) ;

                this.$vToastify.stopLoader();
                this.closeModal();
                this.$vToastify.success("Tipo de Recargo actualizado con éxito", "Éxito");
                this.disabledBtn = false ;
                this.getRecargosTipos();

            } catch (error) {
                
                this.disabledBtn = false ;
                this.$vToastify.stopLoader();
                return this.$vToastify.error(
                    "Error al actualizar Tipo de Recargo. Por favor recargue y vuelva a intentar",
                    "Error"
                );
            }
        }

    },
    watch: {
        dataEditarRecargoType: function (_new) {

            if( _new ){
                this.id   =  +_new.id ;
                this.code =  _new.code ;
                this.name = _new.name ;
                this.description = _new.description ;
                this.logistaasRecharge = _new.logistaas_code ;
            } 
        },
    }
}
</script>

<style>
    .recargosFormType .container-fluid .mx-input{
        border: 0px;
        border-bottom: 1px solid #ccc;
        box-shadow: none;
        border-radius: 0px;
    }

    .recargosFormType .container-fluid .label-datepicker{
        color: rgba(0, 0, 0, 0.54);
        font-size: 0.9375rem;
        font-weight: 700 !important;
        margin-bottom: 0px;
    }

    .recargosFormType .container-fluid .ui-select__label ,
    .recargosFormType .container-fluid .ui-textbox__label-text ,
    .recargosFormType .container-fluid .ui-select.is-disabled .ui-select__display{
        color: rgba(0, 0, 0, 0.54);
        font-weight: 700;
        background-color: unset;
    }

    .recargosFormType .container-fluid .mx-input:disabled, 
    .recargosFormType .container-fluid .ui-select.is-disabled .ui-select__display {
        color: rgba(0, 0, 0, 0.54) !important;
        background-color: unset;
        font-weight: 100 !important
    }

</style>